import React from 'react';
import './index.css';
import { uploadStatusDateFormat } from '../utils/Helper';
import { API_URL, NOTIFICATION_ENUM } from '../utils/Constants';

export const NotificationHistoryCard = ({ item, onClick=null }) => {
    let senderName = item.createdBy || "Unnamed";
    if (senderName.length > 20) senderName = senderName.slice(0, 17) + "...";

    const statusCss = item.filePath ? { color: '#009730', cursor: 'pointer' } : {color: '#FAA13C'};
    const onStatusClick = (e) => {
        if (item.filePath) {
            e.stopPropagation();
            //window.open(item.filePath, '_blank');
            const authCode = localStorage.getItem("bearer");
            const fileName = item.filePath.split("/")[4];
            const url = API_URL.DOWNLOAD_DELIVERY_STATUS_EXCEL_FILE+"?fileName="+fileName;
            fetch(url, {
            method: 'POST',
            headers: {
                'Authorization': authCode,
                'Accept': 'application/json',
            }
            })        
            .then(response => {            
            return response.blob();
            })
            .then(blob => {
                var url = window.URL.createObjectURL(blob);
                var a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox		
                a.click();
                a.remove();  //afterwards we remove the element again         		
            })
            .catch(err => alert(err));
        }
    }

    let recepient = "To: All Grades & Division";
    if (item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT) {
        recepient = "To: ";
        const recipientList = item.pushNotificationConstructRecipients.studentMcBeneficiaryIdList;
        if (recipientList && recipientList.length > 0) {
            recipientList.forEach((value, index) => {
                const separator = index === 0 ? "" : ", ";
                recepient = recepient + separator + value;
            });
        }
    } else if (item.notificationCategoryEnum === NOTIFICATION_ENUM.SCHOOL_CUSTOM) {
        recepient = "To: ";
        const recipientList = item.pushNotificationConstructRecipients.gradeDivisionMapList;
        if (recipientList && recipientList.length > 0) {
            recipientList.forEach((item, index) => {
                const separator = index === 0 ? "" : ", ";
                const division = item.strDivision ? ", "+item.strDivision : "";
                recepient = recepient + separator + item.strGrade+division;
            })
        }
    }

    if (recepient.length > 50) recepient = recepient.slice(0, 47) + "...";

    let messge = item.strSubject;
    if (messge.length > 90) messge = messge.slice(0, 87) + "...";
    
    const iconCss = item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT ? "studentNotificationIcon" : "schoolNotificationIcon";
    let typeName = "All School";
    if (item.notificationCategoryEnum === NOTIFICATION_ENUM.STUDENT) typeName = "Student ID";
    if (item.notificationCategoryEnum === NOTIFICATION_ENUM.SCHOOL_CUSTOM) typeName = "Grades & Divisions";
    
    return (
        <div className="divRow notificationHistoryCard" onClick={() => onClick(item)}>
            <div className="divRow" style={{ alignItems: 'center' }}>
                <div className={iconCss} />
                <div style={{ width: 16 }} />
                <div style={{ width: 140 }}>
                    <label className="label14" style={{ fontWeight: '600', width: 150, margin: 0, whiteSpace: 'nowrap', display: 'inline' }}>{senderName}</label>
                    <div />
                    <label className="label12" style={{ color: '#6d758e' }}>{typeName}</label>
                </div>
                <div style={{ width: 32 }} />
                <div>
                    <label className="label14" style={{ fontWeight: '600', margin: 0, whiteSpace: 'nowrap', display: 'inline' }}>{recepient}</label>
                    <div />
                    <label className="label14" style={{ margin: 0, display: 'inline' }}>{messge}</label>
                </div>
            </div>
            <div>
                <label className="label12" style={{ color: '#6d758e', margin: 0 }}>{uploadStatusDateFormat(item.createdOn)}</label>
                <div />
                
                <label className="label12" style={statusCss} onClick={onStatusClick}>{item.status}</label>
                <label className="label12" style={{ color: '#6d758e', width: '100%', textAlign: 'end' }}>
                    {/* {`Status: `} */}
                </label>
            </div>
            
        </div>
    );
}